var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5574 37.9342H27.5916C27.0311 37.9342 26.5574 37.4527 26.5574 36.8921C26.5574 36.3316 27.039 35.8579 27.5916 35.8579H46.5232V1.99739H2.5969V35.9369H19.6101C20.1706 35.9369 20.6443 36.4184 20.6443 36.979C20.6443 37.5395 20.1627 38.0211 19.6101 38.0211H1.64164C1.08111 38.0211 0.607422 37.5395 0.607422 36.979V1.04211C0.607422 0.481585 1.089 0 1.64164 0H47.5653C48.1259 0 48.5995 0.481585 48.5995 1.04211V36.979C48.5206 37.4606 48.039 37.9342 47.5653 37.9342H47.5574Z",
    fill: "url(#paint0_linear_403_251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.592 47.9132C27.0314 47.9132 26.5578 47.4316 26.5578 46.879V37.9342H20.5656V46.9579C20.5656 47.5185 20.0841 48 19.5314 48C18.9788 48 18.5762 47.4395 18.5762 46.9579V36.979C18.5762 36.4184 19.0577 35.9369 19.6104 35.9369H27.5999C28.1604 35.9369 28.642 36.4184 28.642 36.979V46.9579C28.563 47.4395 28.0814 47.9132 27.5999 47.9132H27.592Z",
    fill: "url(#paint1_linear_403_251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5451 47.9132H16.5714C16.0109 47.9132 15.5293 47.4316 15.5293 46.879C15.5293 46.3263 16.0109 45.8369 16.5714 45.8369H30.5451C31.1056 45.8369 31.5793 46.3184 31.5793 46.879C31.5793 47.4395 31.0977 47.9132 30.5451 47.9132Z",
    fill: "url(#paint2_linear_403_251)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5575 32.9842H1.63382C1.07329 32.9842 0.599609 32.5027 0.599609 31.9421C0.599609 31.3816 1.08119 30.9 1.63382 30.9H47.5575C48.118 30.9 48.5917 31.3816 48.5917 31.9421C48.5917 32.5027 48.0312 32.9842 47.5575 32.9842Z",
    fill: "url(#paint3_linear_403_251)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5364 27.9474H14.5733C14.0127 27.9474 13.5391 27.4658 13.5391 26.9053V5.98422C13.5391 5.42369 14.0206 4.95001 14.5733 4.95001H21.2049C21.7654 4.95001 22.2391 5.43159 22.2391 5.98422C22.2391 6.53685 21.7575 7.02633 21.2049 7.02633H15.6154V25.95H35.5812V7.02633H29.5891C29.0285 7.02633 28.5549 6.54475 28.5549 5.98422C28.5549 5.42369 29.0364 4.95001 29.5891 4.95001H36.6154C37.1759 4.95001 37.6496 5.43159 37.6496 5.98422V26.9921C37.5706 27.4737 37.0891 27.9474 36.5285 27.9474H36.5364Z",
    fill: "url(#paint4_linear_403_251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5884 15.0079H21.2042C20.6437 15.0079 20.1621 14.5263 20.1621 13.9658V5.97632C20.1621 5.41579 20.6437 4.94211 21.2042 4.94211H29.5884C30.1489 4.94211 30.6226 5.42369 30.6226 5.97632V13.9658C30.5437 14.5263 30.0621 15.0079 29.5884 15.0079ZM22.1595 13.0184H28.5463V7.02633H22.1595V13.0184Z",
    fill: "url(#paint5_linear_403_251)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5947 19.9658H19.6026C19.042 19.9658 18.5684 19.4842 18.5684 18.9237C18.5684 18.3632 19.0499 17.8895 19.6026 17.8895H25.5947C26.1552 17.8895 26.6289 18.3711 26.6289 18.9237C26.5499 19.4842 26.0684 19.9658 25.5947 19.9658Z",
    fill: "url(#paint6_linear_403_251)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5973 23.9527H19.6026C19.042 23.9527 18.5684 23.4711 18.5684 22.9185C18.5684 22.3658 19.0499 21.8763 19.6026 21.8763H23.5973C24.1578 21.8763 24.6315 22.3579 24.6315 22.9185C24.5526 23.479 24.071 23.9527 23.5973 23.9527Z",
    fill: "url(#paint7_linear_403_251)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_251",
    x1: 24.6035,
    y1: 0,
    x2: 24.6035,
    y2: 38.0211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_251",
    x1: 23.6091,
    y1: 35.9369,
    x2: 23.6091,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_251",
    x1: 23.5543,
    y1: 45.8369,
    x2: 23.5543,
    y2: 47.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_251",
    x1: 24.5957,
    y1: 30.9,
    x2: 24.5957,
    y2: 32.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_251",
    x1: 25.5943,
    y1: 4.95001,
    x2: 25.5943,
    y2: 27.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_251",
    x1: 25.3924,
    y1: 4.94211,
    x2: 25.3924,
    y2: 15.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_251",
    x1: 22.5986,
    y1: 17.8895,
    x2: 22.5986,
    y2: 19.9658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_251",
    x1: 21.5999,
    y1: 21.8763,
    x2: 21.5999,
    y2: 23.9527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon22);
export default __webpack_public_path__ + "static/media/icon22.c2075f09efc047866d6c9f4b89136ccf.svg";
export { ForwardRef as ReactComponent };